/**
 * Approvals — Layout route
 *
 * Universal human-in-the-loop approval system.
 * Tabs: Inbox, History, Settings
 */

import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { ContentHeader } from '@/components/content-header';
import { Clock, History, Settings } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { usePendingApprovals } from '@/lib/use-agent-approvals';

export const Route = createFileRoute('/approvals')({
  component: ApprovalsLayout,
});

function ApprovalsLayout() {
  const location = useLocation();

  const TAB_PATHS = ['/approvals', '/approvals/', '/approvals/history', '/approvals/history/', '/approvals/settings', '/approvals/settings/'];
  const isTabPage = TAB_PATHS.includes(location.pathname);

  // Real-data: agent_tool_approvals where status=pending
  const { data: pending = [] } = usePendingApprovals();
  const pendingCount = pending.length;

  return (
    <div className="flex flex-col h-full">
      {isTabPage && (
        <ContentHeader
          title="Approvals"
          tabs={[
            { label: 'Inbox', path: '/approvals', icon: Clock },
            { label: 'History', path: '/approvals/history', icon: History },
            { label: 'Settings', path: '/approvals/settings', icon: Settings },
          ]}
          actions={
            <Badge variant="secondary" className="text-[9px]">{pendingCount} pending</Badge>
          }
        />
      )}
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
